// extracted by mini-css-extract-plugin
export var action = "styles-module--action--b102a";
export var action___large = "styles-module--action___large--fe180";
export var action___small = "styles-module--action___small--16020";
export var bounce = "styles-module--bounce--a20bd";
export var pulse = "styles-module--pulse--027f5";